/*
 *
 * Navigation actions
 *
 */

import axios from "axios";
import handleError from "../../utils/error";
import {
  TOGGLE_MENU,
  TOGGLE_FILTER,
  TOGGLE_CART,
  TOGGLE_BRAND,
  SEARCH_CHANGE,
  SUGGESTIONS_FETCH_REQUEST,
  SUGGESTIONS_CLEAR_REQUEST,
} from "./constants";
import { API_URL } from "../../constants";

export const toggleMenu = () => {
  return {
    type: TOGGLE_MENU,
  };
};

export const toggleFilter = () => {
  return {
    type: TOGGLE_FILTER,
  };
};

export const toggleCart = () => {
  return {
    type: TOGGLE_CART,
  };
};

export const toggleBrand = () => {
  return {
    type: TOGGLE_BRAND,
  };
};

export const onSearch = (v) => {
  return {
    type: SEARCH_CHANGE,
    payload: v,
  };
};

export const onSuggestionsFetchRequested = (value) => {
  const inputValue = value.value.trim().toLowerCase();

  return async (dispatch, getState) => {
    try {
      if (inputValue && inputValue.length % 3 === 0) {
        const response = await axios.get(
          `${API_URL}/product/list/search/${inputValue}`
        );
        dispatch({
          type: SUGGESTIONS_FETCH_REQUEST,
          payload: response.data.products,
        });
      }
    } catch (error) {
      handleError(error, dispatch);
    }
  };
};

export const onSuggestionsClearRequested = () => {
  return {
    type: SUGGESTIONS_CLEAR_REQUEST,
    payload: [],
  };
};
